import Panel from '../ui/Panel'
import { distanceKm, median } from '../lib/geo'
import { formatDistance } from '../lib/format'
import type { DnsechoRow, IpDetails } from '@shared/api'
import styles from './DistanceStat.module.css'

interface DistanceStatProps {
    rows: DnsechoRow[]
    self: IpDetails | undefined
}

/**
 * Deliberately a stat tile rather than a chart. With two to five resolvers a bar
 * chart of distances is a one-bar chart in costume; the numbers *are* the
 * visualisation. Distance is a proxy for the thing that matters to a privacy
 * audience: which jurisdiction is answering your lookups.
 */
export default function DistanceStat({ rows, self }: DistanceStatProps) {
    const distances = rows
        .map((r) => distanceKm(self?.location, r.location))
        .filter((d): d is number => d !== undefined)

    const countries = [...new Set(rows.map((r) => r.cc).filter(Boolean))]
    const asns = new Set(rows.map((r) => r.asnNumber).filter((a) => a !== undefined))

    return (
        <div className={styles.grid}>
            <Panel title="Distance">
                <p className={styles.stat}>
                    <span className={styles.figure}>{formatDistance(median(distances))}</span>
                    <span className={styles.unit}>median</span>
                </p>
                <p className={styles.stat}>
                    <span className={styles.figureSmall}>
                        {formatDistance(distances.length ? Math.max(...distances) : undefined)}
                    </span>
                    <span className={styles.unit}>farthest</span>
                </p>
            </Panel>

            <Panel title="Jurisdictions">
                <p className={styles.countries}>{countries.join(' · ') || '—'}</p>
                <p className={styles.unit}>
                    {countries.length} {countries.length === 1 ? 'country' : 'countries'}, {asns.size} ASN{asns.size === 1 ? '' : 's'}
                </p>
            </Panel>
        </div>
    )
}
